// src/pages/Login.jsx
import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box, Alert } from '@mui/material';
import { loginUser } from '../lib/api';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    try {
      const token = await loginUser(email, password);
      localStorage.setItem("accessToken", token);
      setSuccessMsg("ログイン成功！");
      
      // ✅ 1.5秒後にホームにリダイレクト
      setTimeout(() => navigate("/"), 1500);
    } catch (err) {
      setErrorMsg(err.message);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 6 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        ログイン
      </Typography>

      <form onSubmit={handleSubmit}>
        <TextField
          label="メールアドレス"
          type="email"
          fullWidth
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <TextField
          label="パスワード"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" fullWidth>
            ログイン
          </Button>
        </Box>
      </form>

      {errorMsg && <Alert severity="error" sx={{ mt: 2 }}>{errorMsg}</Alert>}
      {successMsg && <Alert severity="success" sx={{ mt: 2 }}>{successMsg}</Alert>}
    </Container>
  );
};

export default Login;